import FanBookmarksComponent from "./FanBookmarksComponent";
export default FanBookmarksComponent;
